/**
 * Constants definition.
 *
 * @type {{PENDING: string, ACCEPTED: string, CANCELED: string, IN_REVIEW: string}}
 */
const CANCEL_AUTHORIZATION_STATUS = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  CANCELED: 'CANCELED',
};

/**
 * Enum definition.
 *
 * @type {string[]}
 */
const CANCEL_AUTHORIZATION_STATUS_ENUM = Object.keys(CANCEL_AUTHORIZATION_STATUS);

export {
  CANCEL_AUTHORIZATION_STATUS_ENUM,
  CANCEL_AUTHORIZATION_STATUS,
};
